import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=dddd65d6&"
import script from "./properties.vue?vue&type=script&lang=ts&"
export * from "./properties.vue?vue&type=script&lang=ts&"
import style0 from "./properties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports